import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface InvoicesCardType {
  data: unknown | null;
  loading: boolean;
  error: string | null;
  get: (cardId: number, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useInvoicesStore = create<InvoicesCardType>((set) => ({
  data: null,
  loading: false,
  error: null,

  get: ApiUtils.wrapperApi(async (cardId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardsApi.getInvoicesCard(cardId, signal);
      set({ data: result ?? null, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: null, loading: false, error: null }),
}));
